
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class IconWithTooltip extends Vue {
  @Prop({ type: String, required: true, default: 'mdi-wrench' }) public icon!: string;
  @Prop({ type: String, required: true, default: 'white' }) public description!: string;
  @Prop({ type: Number, required: false, default: 16 }) public size!: number;
  @Prop({ type: String, required: false, default: 'white' }) public color!: string;
  @Prop({ type: String, required: false, default: '' }) public content!: string;
}
